import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';

let theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#2b4890",
      light: '#42a5f5',
      dark: "#1565c0",
      contrastText: '#fff',
    },
    'selectedColor':'#b7e4ff',
  },
});

theme = createTheme(theme, {
  components:{
    'MuiTable':{
      styleOverrides:{
        root:{
          //backgroundColor: '#b7e4ff'
        },
      }
    },
    'MuiTableRow':{
      styleOverrides:{
        root:{
          //backgroundColor: '#b7e4ff',
          '&.Mui-selected': {
            backgroundColor: theme.palette.selectedColor,
            '&:hover':{
              backgroundColor: theme.palette.selectedColor,
            }
          },
          '&.MuiTableRow-hover':{
              '&:hover':{
                //backgroundColor: '#b7e4ff'
              },
            }
        }, 
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          //fontSize: '1rem',
        },
      },
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
